import React, { useEffect, useState } from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { trackOrderPaymentSucceeded, trackOrderPaymentFailed, trackPaymentGatewayError } from "../../utils/mixpanel";

const CheckCheckout = ({ status, message, sessionId, urlAPI, navigatUrl }) => {
  console.log("status", status);
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  var url = new URLSearchParams(location.search);
  var statusValue = url.get("status");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // if (status == "false") {
  //   navigate(`/${room_uuid}/Checkout`, {
  //     state: { metadata: "message" },
  //   });
  // }

  useEffect(() => {
    if (status == "true" || sessionId) {
      const About = async () => {
        setLoading(true);
        // axios.get(`/648ed77e-da78-4987-9b86-de515659fc2c`).then((res) => {
        axios.get(`/${room_uuid}/${urlAPI}`).then((res) => {
          const data = res.data.data;
          setData(data);
          console.log("data***", data);

          // Track payment success
          trackOrderPaymentSucceeded({
            order_number: data?.order_number || data?.orderNumber || "",
            payment_method: data?.payment_method_text || data?.paymentMethodText || "",
            gateway_transaction_id: url.get("transaction_id") || "",
            amount: data?.total || data?.order_price?.total || 0,
            currency: localStorage.getItem("currency") || "AED",
          });

          navigate(`/${room_uuid}/${navigatUrl}`, {
            state: { metadata: res.data.data },
             replace: true,
          });
          setLoading(false);
        });
      };
      About();
    } else {
      // Track payment failure
      trackOrderPaymentFailed({
        order_number: "",
        amount: 0,
        payment_method: "",
        gateway: "",
        failure_reason: message || "Payment failed",
      });

      // Also track as gateway error if there's an error message
      if (message) {
        trackPaymentGatewayError({
          gateway: "",
          error_code: statusValue || "unknown",
          error_message: message,
        });
      }

      navigate(`/${room_uuid}/Checkout`, {
        state: { metadata: message },
        replace: true,
      });
    }
  }, []);
  return <></>;
};

export default CheckCheckout;
